import { Business } from "./BusinessDropdownResponse";
import { Hierarchy } from "./HierarchyDropdownResponse";
import { Segment } from "./SegmentDropdownResponse";
import { Status } from "./StatusDropdownResponse";
import { TypeDropdown } from "./TypeDropdownResponse";

export class EstimateSearchDropDownDataResponse {
    business: Business[] = [];
    segment: Segment[] = [];
    status: Status[] = [];
    hierarchy: Hierarchy[] = [];
    type: TypeDropdown[] = [];
}